import script from "./PageRenderTransitionHandler.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageRenderTransitionHandler.vue?vue&type=script&lang=ts&setup=true"

import "./PageRenderTransitionHandler.vue?vue&type=style&index=0&id=cd3426ea&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd3426ea"]])

export default __exports__